
import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

import { MultiStepFormStore } from '../../../infrastructure/types/multi-step-form.types';
import { EnvironmentBuildInfo } from "../../environment-build-info/environment-build-info";
import { LeftMenu } from '../left-menu/left-menu';

@Component({
  standalone: true,
  selector: 'remote-update-domain-multi-step-form',
  imports: [ReactiveFormsModule, FormsModule, MatButton, LeftMenu, EnvironmentBuildInfo],

  templateUrl: './multi-step-form.html',
  styleUrls: ['./multi-step-form.css']
})
export class MultiStepForm {
 @Input({ required: true }) store?: MultiStepFormStore;
  @Output() formCancel = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();
  @Input() actionButtonLabel!: boolean;
  @Input() modelTitle = 'Firmware Package';
  @Input() menuItems: { id: string; label: string }[] = [];
  @Input() finalButtonText = '';

  get currentSection(): string {
    return this.store?.currentSection() ?? '';
  }
  isEditingFirmwarePackage = computed(() => this.store?.isEditingFirmwarePackage?.() ?? false);
  isEditingRolloutPlan = computed(() => this.store?.isEditingRolloutPlan?.() ?? false);

  goToSection(section: string) {
    this.store?.setCurrentSection(section);
  }
}
